module.exports = __webpack_public_path__ + "static/client-connect-3102482ca79c596508be539a26faf7d0.png";